import { IProduct } from '@/creditflowresearch/domain/vo/Product';
import Product from '@/creditflowresearch/domain/Product/Product';

export const parseProductIdsFromQuery = (
  queryString: string | undefined,
  productsList: IProduct[],
): string[] => {
  if (!queryString || !productsList?.length) {
    return [];
  }

  return Product.getIds(queryString);
};
